<template>
  <el-dialog
    class="vote-detail-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <div class="vote-body">
      <div v-for="item in Object.keys(voteLabel)" :key="item" class="detail-box">
        <div class="detail-head">{{ item }}</div>
        <div v-for="ele in voteLabel[item]" :key="ele.label" class="detail-line">
          <div class="label">{{ ele.label }}</div>
          <div v-if="ele.formatter" class="con">{{ ele.formatter(voteData[ele.value]) }}</div>
          <div v-else class="con">{{ voteData[ele.value] || $constants.EMPTY }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VoteDetail',
  data() {
    return {
      title: '投票详情',
      dialogVisible: false,
      voteLabel: {
        投票议案: [
          {
            label: '投票事件',
            value: 'VoteType',
            formatter: data => {
              return this.voteEvent(data)
            }
          },
          { label: '发起组织', value: 'StartOrgName' },
          {
            label: '投票状态',
            value: 'VoteStatus',
            formatter: row => {
              return this.voteStatus(row)
            }
          },
          { label: '议案详情', value: 'VoteDetail' },
          { label: '投票原因', value: 'Reason' }
        ],
        投票情况: [
          { label: '投同意票', value: 'PassOrgs' },
          { label: '同意比例', value: 'PassPercent' },
          { label: '未投票', value: 'UnVotedOrgs' },
          { label: '未投票比例', value: 'UnVotedPercent' }
        ]
      },
      voteData: {}
    }
  },
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.voteData = data
      this.voteData.PassOrgs = this.$utils.isEmpty(data.PassOrgs) ? '' : data.PassOrgs.toString()
      this.voteData.UnVotedOrgs = this.$utils.isEmpty(data.UnVotedOrgs)
        ? ''
        : data.UnVotedOrgs.toString()
      this.dialogVisible = true
    },
    voteEvent(val) {
      let eventList = [
        '节点增加更新',
        '根证书更新',
        '共识删除',
        '更新区块配置',
        '部署合约',
        '更新合约',
        '冻结合约',
        '解冻合约',
        '撤销合约'
      ]
      return eventList[val]
    },
    voteStatus(status) {
      let statusArr = ['投票中', '投票完成']
      return statusArr[status]
    },
    handleOk() {}
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'vote-detail-dialog',
  (
    --vote-detail-dialog-detail-head-background-color: #4b5471,
    --vote-detail-dialog-detail-head-color: #a3afb5,
    --vote-detail-dialog-detail-border-color: #4b5471,
    --vote-detail-dialog-detail-key-color: #A5B3B9,
    --vote-detail-dialog-detail-value-color: #fff
  ),
  (
    --vote-detail-dialog-detail-head-background-color: #ebebeb,
    --vote-detail-dialog-detail-head-color: #192227,
    --vote-detail-dialog-detail-border-color: #ebebeb,
    --vote-detail-dialog-detail-key-color: #5A6973,
    --vote-detail-dialog-detail-value-color: #192227
  )
);
.vote-detail-dialog.common-dialog {
  @include adaptation(
    (
      --vote-detail-dialog-body-padding-bottom: 28px,
      --vote-detail-dialog-detail-min-height: 204px,
      --vote-detail-dialog-detail-border-width: 1px,
      --vote-detail-dialog-detail-border-radius: 4px,
      --vote-detail-dialog-detail-margin-bottom: 20px,
      --vote-detail-dialog-detail-head-height: 42px,
      --vote-detail-dialog-detail-head-padding: 0 12px,
      --vote-detail-dialog-detail-head-fontsize: 16px,
      --vote-detail-dialog-detail-body-fontsize: 14px,
      --vote-detail-dialog-detail-body-padding: 12px 12px 8px,
      --vote-detail-dialog-detail-label-width: 88px,
      --vote-detail-dialog-detail-label-padding-right: 12px
    )
  );
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);

    .el-dialog__body {
      padding-bottom: var(--vote-detail-dialog-body-padding-bottom);
    }
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .detail-box {
    min-height: var(--vote-detail-dialog-detail-min-height);
    border: var(--vote-detail-dialog-detail-border-width) solid var(--vote-detail-dialog-detail-border-color);
    border-radius: var(--vote-detail-dialog-detail-border-radius);

    &:not(:last-child) {
      margin-bottom: var(--vote-detail-dialog-detail-margin-bottom);
    }

    .detail-head {
      height: var(--vote-detail-dialog-detail-head-height);
      line-height: var(--vote-detail-dialog-detail-head-height);
      padding: var(--vote-detail-dialog-detail-head-padding);
      border-bottom: var(--vote-detail-dialog-detail-border-width) solid var(--vote-detail-dialog-detail-border-color);
      font-size: var(--vote-detail-dialog-detail-head-fontsize);
      background-color: var(--vote-detail-dialog-detail-head-background-color);
      color: var(--vote-detail-dialog-detail-head-color);
    }
    .detail-line {
      display: flex;
      align-items: flex-start;
      font-size: var(--vote-detail-dialog-detail-body-fontsize);
      padding: var(--vote-detail-dialog-detail-body-padding);
      .label {
        width: var(--vote-detail-dialog-detail-label-width);
        padding-right: var(--vote-detail-dialog-detail-label-padding-right);
        color: var(--vote-detail-dialog-detail-key-color);
      }
      .con {
        flex: 1;
        color: var(--vote-detail-dialog-detail-value-color);
      }
    }
  }
}
</style>
